<template>
  <div class="cash-widget" @click="onClick">
    <div class="cash-widget__icon">
      <!-- ovde možeš ubaciti i <img> umesto emoji-ja -->
      💵
    </div>

    <div class="cash-widget__content">
      <div class="cash-widget__title">{{locale.t('label_cash_register')}}</div>
<!--      Za sad uvek sklonjeno-->
<!--      <div class="cash-widget__subtitle" v-if="showCurrentState">{{locale.t('label_cash_current_state')}}</div>-->
<!--      <div class="cash-widget__amount" v-if="showCurrentState">-->
<!--        {{ formattedAmount }}-->
<!--      </div>-->
    </div>

    <div class="cash-widget__chevron">›</div>
  </div>
</template>

<script>
import Loc from "../services/localization";
import CONFIG_COMPANY from "../services/myConfig";

const LocService = new Loc()

export default {
  data() {
    return {
      locale: LocService,
      showCurrentState: CONFIG_COMPANY.SHOW_CURRENT_STATE_IN_CASH_REGISTER != null ? CONFIG_COMPANY.SHOW_CURRENT_STATE_IN_CASH_REGISTER : true
    }
  },

  name: 'CashRegisterWidget',
  props: {
    amount: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      default: 'RSD'
    }
  },
  computed: {
    formattedAmount() {
      return new Intl.NumberFormat('sr-RS', {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: 0
      }).format(this.amount)
    }
  },
  methods: {
    onClick() {
      // emituješ event, ti u parentu otvaraš stranicu sa računima
      this.$emit('open-cash-register')
    }
  }
}
</script>


// WEBPACK FOOTER //
// CashRegisterWidget.vue?4da22ac3